import React, { useContext, useEffect } from "react";
import socket from "../Config/Socket";
import { useAppContext } from "./AppContext";
import { Toast } from "../Hooks/useToast";


const SocketContext = React.createContext();

export function useSocket() {
  return useContext(SocketContext);
}


export function SocketProvider({ children }) {
  const { isLoggedIn, isSocketConnected, updateSocketStatus, user, logout, isWebView } = useAppContext()


  useEffect(() => {
    if (isLoggedIn) {
      socket.connectToSocket(
        user?.api_token,
        () => {
          if (!isWebView) {
            logout()
          }
          else {
            if (window?.FlutterChannel) {
              window.FlutterChannel.postMessage("logout");
            }
            else {
              Toast("Flutter Channel Not Found. Unauthorized socket access", 'error', false);
            }
          }
        },
        () => {
          updateSocketStatus(true)
        });
    }
    return () => {
      if (isLoggedIn && isSocketConnected) {
        socket.disconnect();
        updateSocketStatus(false)
      }
    }
  }, [isLoggedIn])

  return <SocketContext.Provider value={socket}>
    {children}
  </SocketContext.Provider>
}